import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Input } from 'reactstrap'

import Editor from '../../../../../partials/Editor'

import style from '../../style'

export const EditTableRow = props => {
  const groupedContent = props.content.reduce((groups, item) => {
    groups[item.type] = [...(groups[item.type] || [])]
    groups[item.type].push(item)
    return groups
  }, {})

  return (
    <tr className={css(style.editable.wrapper)}>
      <td className={css(style.table.td)}>
        <span className={css(style.tableRow.title)}>{props.title}</span>
      </td>
      <td className={css(style.table.td)}>
        <form onSubmit={props.onFormSubmit}>
          <Row className={css(style.editable.hNotes)}>
            <Col>
              {(groupedContent.hNote || []).map((item, index) => (
                <p
                  key={`hp_${index}`}
                  className={css(style.editable.p)}
                  style={{ fontStyle: item.style || 'normal' }}
                >
                  {item.value}
                </p>
              ))}
            </Col>
          </Row>

          <Row>
            <Col>
              {(groupedContent.selector || []).map((item, index) => (
                <RenderInput
                  key={index}
                  {...item}
                  type={`selector`}
                  onChange={props.onInputChange}
                />
              ))}
              {(groupedContent.input || []).map((item, index) => (
                <RenderInput
                  key={index}
                  {...item}
                  type={`text`}
                  onChange={props.onInputChange}
                />
              ))}
              {(groupedContent.checkbox || []).map((item, index) => (
                <RenderInput
                  key={index}
                  {...item}
                  type={`checkbox`}
                  onChange={props.onInputChange}
                />
              ))}
              {(groupedContent.wysiwyg || []).map((item, index) => (
                <RenderInput
                  key={index}
                  {...item}
                  type={`wysiwyg`}
                  onChange={props.onWysiwygChange}
                  staticContext={props.staticContext}
                />
              ))}
            </Col>
          </Row>

          <Row className={css(style.editable.bNotes)}>
            <Col>
              {(groupedContent.bNote || []).map((item, index) => (
                <p
                  key={`bp_${index}`}
                  className={css(style.editable.p)}
                  style={{ fontStyle: item.style || 'normal' }}
                >
                  {item.value}
                </p>
              ))}
            </Col>
          </Row>
          <Row>
            <Col xs='auto'>
              <input
                type={'submit'}
                value={'Save'}
                className={css(style.editable.button, style.editable.submit)}
              />
            </Col>
            <Col xs='auto'>
              <input
                type={'button'}
                value={'Cancel'}
                onClick={props.onCancelClick}
                className={css(style.editable.button)}
              />
            </Col>
          </Row>
        </form>
      </td>
      <td className={css(style.table.td)} />
    </tr>
  )
}

const RenderInput = props => {
  if (props.type === 'wysiwyg') {
    return <RenderWysiwygInput {...props} />
  }

  if (props.type === 'selector') {
    return <RenderSelectorInput {...props} />
  }

  return (
    <Row className={css(style.editable.row)}>
      <Col
        xs='12'
        md='4'
        className={`
        ${props.showLabel ? `d-flex` : `d-none`}
        align-items-center justify-content-end
      `}
      >
        <span className={css(style.editable.nameSpan)}>
          {props.label || props.name}
        </span>
      </Col>
      <Col>
        <Input
          key={`input_${props.name}`}
          type={props.type}
          name={props.name}
          onChange={props.onChange}
          defaultValue={props.value}
          {...(props.type === 'checkbox' ? { checked: props.value } : {})}
          className={css(
            style.editable.input,
            props.showLabel ? null : style.editable.fullWidthInput
          )}
        />
      </Col>
    </Row>
  )
}

const RenderWysiwygInput = props => {
  return (
    <Row className={css(style.editable.row, style.editable.wysiwyg)}>
      <Col>
        <Editor
          initialValue={props.editor.value}
          onHTMLChange={props.onChange}
        />
      </Col>
    </Row>
  )
}

const RenderSelectorInput = props => {
  return (
    <Row className={css(style.editable.row)}>
      <Col
        xs='12'
        md='4'
        className={`
        ${props.showLabel ? `d-flex` : `d-none`}
        align-items-center justify-content-end
      `}
      >
        <span className={css(style.editable.nameSpan)}>
          {props.label || props.name}
        </span>
      </Col>
      <Col>
        <select
          key={`input_${props.name}`}
          type={props.type}
          name={props.name}
          onChange={props.onChange}
          defaultValue={props.value}
          className={css(
            style.editable.selector,
            props.showLabel ? null : style.editable.fullWidthInput
          )}
        >
          {props.options.map((option, index) => (
            <option key={index} value={index}>
              {option.label}
            </option>
          ))}
        </select>
      </Col>
    </Row>
  )
}

export default EditTableRow



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/partials/EditTableRow/index.js